import { motion } from 'framer-motion';

export function LocalExpertSection() {
  const differentiators = [
    {
      icon: 'ri-user-heart-line',
      color: 'from-[#FF8E53] to-[#ff7a3d]',
      title: '1:1 맞춤 여행 설계',
      description: '패키지를 파는 게 아니라 당신의 이야기를 씁니다. 가족 구성원, 체력, 취향, 예산까지 모두 반영한 세상에 하나뿐인 여행 코스',
      tags: ['개인 취향 반영', '유연한 일정 조정', '여행 중 변경 가능']
    },
    {
      icon: 'ri-map-pin-user-line',
      color: 'from-[#0E7FC0] to-[#0a5f92]',
      title: '로컬 전문가 큐레이션',
      description: '10년 이상 제주에서 살아온 로컬만이 알고 있는 숨은 명소, 진짜 맛집, 최적의 타이밍. 그 누구도 알려주지 않는 진짜 제주를 경험하세요',
      tags: ['숨은 명소 소개', '로컬 맛집', '포토 스팟 안내']
    },
    {
      icon: 'ri-vip-crown-line',
      color: 'from-[#4A7C59] to-[#3a6347]',
      title: '프리미엄 이동 서비스',
      description: '대형 VIP 리무진부터 벤츠 스프린터까지, 이동 자체가 여행의 일부가 됩니다. 편안하고 품격 있는 이동으로 여행의 질을 높이세요',
      tags: ['VIP 리무진', '벤츠 스프린터', '전세버스']
    },
    {
      icon: 'ri-customer-service-2-line',
      color: 'from-[#FF1493] to-[#d4006e]',
      title: '친구 같은 동행 서비스',
      description: '단순한 가이드가 아닌, 제주를 함께 즐기는 친구가 되어드립니다. 예약부터 귀가까지 세심하게 케어하는 진정한 올인원 여행 파트너',
      tags: ['24시간 케어', '여행 전후 상담', '응급 상황 대처']
    }
  ];

  return (
    <section className="py-20 sm:py-24 md:py-28 bg-white" id="about">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8">

        {/* Section Header */}
        <div className="text-center mb-16 sm:mb-20">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-3 bg-[#FF8E53]/10 px-6 py-3 rounded-full mb-6 sm:mb-8"
          >
            <i className="ri-award-line text-[#FF8E53] text-xl"></i>
            <span className="text-[#FF8E53] text-base sm:text-lg font-medium">왜 제주블리인가?</span>
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#2C2C2C] mb-6 sm:mb-8 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            제주를 가장<br />
            <span className="text-[#0E7FC0]">제주답게</span>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto leading-relaxed"
          >
            수많은 제주 여행사 중 제주블리를 선택해야 하는 이유,<br />
            직접 확인해보세요
          </motion.p>
        </div>

        {/* Story Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-24 sm:mb-32">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/7a11be136ee03b3ecdb1f82c29f6a360.jpg"
                alt="제주블리 로컬 가이드"
                className="w-full h-[400px] sm:h-[500px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <div className="bg-white/95 backdrop-blur-sm rounded-2xl p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <div className="w-14 h-14 rounded-full overflow-hidden shadow-lg">
                      <img
                        src="https://static.readdy.ai/image/c1ead532c50398fda057e46e940be938/e04f99b6877b66d4ca7caa0ce01baead.jpeg"
                        alt="제주블리"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <p className="font-bold text-[#2C2C2C] text-lg">권병주 대표</p>
                      <p className="text-[#0E7FC0] text-sm font-medium">제주블리 창업자 &amp; 로컬 전문가</p>
                    </div>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed italic">
                    "10년 넘게 제주 곳곳을 누비며 쌓아온 경험을 여러분과 나누고 싶었습니다.
                    진짜 제주를 아는 사람만이 안내할 수 있는 특별한 여행, 제주블리가 함께하겠습니다."
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div>
              <h3 className="text-3xl sm:text-4xl font-bold text-[#2C2C2C] mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                로컬 전문가가 만드는<br />차별화된 제주 여행
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                제주블리는 단순한 여행사가 아닙니다. 제주를 가장 잘 아는 로컬 전문가가
                당신만을 위한 맞춤 여행을 설계합니다. 10년 이상의 현지 경험으로
                관광객이 절대 혼자서는 찾을 수 없는 숨은 명소와 진짜 제주를 경험하게 해드립니다.
              </p>
            </div>

            <div className="space-y-4">
              {[
                { icon: 'ri-checkbox-circle-fill', color: 'text-[#4A7C59]', text: '10년+ 제주 로컬 전문가 직접 운영' },
                { icon: 'ri-checkbox-circle-fill', color: 'text-[#0E7FC0]', text: '500+ 누적 고객 | 92% 재방문율' },
                { icon: 'ri-checkbox-circle-fill', color: 'text-[#FF8E53]', text: '평균 별점 4.9/5.0 고객 만족도' },
                { icon: 'ri-checkbox-circle-fill', color: 'text-[#FF1493]', text: '1:1 맞춤 설계 | 정해진 코스 없음' },
              ].map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1 }}
                  className="flex items-center gap-4"
                >
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-2xl ${item.color}`}></i>
                  </div>
                  <span className="text-lg text-gray-700 font-medium">{item.text}</span>
                </motion.div>
              ))}
            </div>

            <motion.a
              href="tel:010-5685-7818"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center gap-3 bg-gradient-to-r from-[#FF8E53] to-[#ff7a3d] text-white px-8 py-4 rounded-full text-lg font-bold shadow-xl hover:shadow-[#FF8E53]/40 transition-all whitespace-nowrap"
            >
              <i className="ri-phone-line text-xl"></i>
              무료 상담 신청하기
            </motion.a>
          </motion.div>
        </div>

        {/* Differentiators */}
        <div className="mb-24 sm:mb-32">
          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] text-center mb-12 sm:mb-16"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            4가지 핵심 차별화 포인트
          </motion.h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {differentiators.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="group"
              >
                <div className="bg-white border-2 border-gray-100 rounded-3xl p-8 hover:border-transparent hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 h-full">
                  <div className={`w-16 h-16 bg-gradient-to-br ${item.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform shadow-lg`}>
                    <i className={`${item.icon} text-3xl text-white`}></i>
                  </div>
                  <h4 className="text-2xl font-bold text-[#2C2C2C] mb-3">{item.title}</h4>
                  <p className="text-gray-600 leading-relaxed mb-5 text-base">{item.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {item.tags.map((tag, idx) => (
                      <span key={idx} className="text-sm bg-gray-100 text-gray-700 px-3 py-1 rounded-full font-medium">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Numbers */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20 sm:mt-24 grid grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {[
            { number: '10년+', label: '제주 로컬 경험', icon: 'ri-map-pin-2-line', color: 'from-[#FF8E53] to-[#ff7a3d]' },
            { number: '500+', label: '누적 고객', icon: 'ri-user-heart-line', color: 'from-[#0E7FC0] to-[#0a5f92]' },
            { number: '4.9★', label: '평균 별점', icon: 'ri-star-fill', color: 'from-[#4A7C59] to-[#3a6347]' },
            { number: '92%', label: '재방문율', icon: 'ri-repeat-line', color: 'from-[#FF1493] to-[#d4006e]' },
          ].map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`bg-gradient-to-br ${stat.color} rounded-3xl p-8 text-white text-center shadow-xl hover:-translate-y-1 transition-transform`}
            >
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-3xl`}></i>
              </div>
              <div className="text-4xl sm:text-5xl font-bold mb-2">{stat.number}</div>
              <div className="text-white/90 font-medium">{stat.label}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
